export default __webpack_public_path__ + "static/media/slide7.a88ef64d.jpg";